<template>
  <form>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon v-if="!everythingLoaded" class="load-rotate"
            >{{ formIcon }}
          </md-icon>
          <md-icon v-if="everythingLoaded">{{ formIcon }}</md-icon>
        </div>
        <h4 class="title">{{ title }}</h4>
      </md-card-header>

      <md-card-content v-if="everythingLoaded">
        <ValidationProvider
          name="name"
          rules="required|min:2"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Import template</label>
            <md-select
              v-model="templateId"
              :name="'templateId'"
              :id="'templateId'"
              required
              :disabled="!everythingLoaded || $route.params.id !== undefined"
            >
              <md-option
                v-for="(importTemplateOption,
                importTemplateIndex) in importTemplates"
                :value="importTemplateOption['id']"
                :key="importTemplateIndex"
                >{{ importTemplateOption["name"] }}
              </md-option>
            </md-select>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <md-field
          v-if="
            status === 0 &&
              (!everythingLoaded || $route.params.id !== undefined)
          "
          class="md-valid"
        >
          <file-picker
            v-model="fileData"
            :disabled="updateRequest"
            label="Kies een bestand"
            :class-name="[
              { 'md-success': fileData === null },
              { 'md-primary': fileData !== null }
            ]"
            content-types="text/csv,application/vnd.oasis.opendocument.spreadsheet,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ></file-picker>
        </md-field>
        <md-field
          v-if="
            filename &&
              status === 0 &&
              (!everythingLoaded || $route.params.id !== undefined)
          "
          class="md-valid"
        >
          <div class="file-info">Gekozen bestand: {{ filename }}</div>
        </md-field>

        <md-table
          v-if="
            (status === 1 || status === 2 || status === 3) &&
              (!everythingLoaded || $route.params.id !== undefined)
          "
          class=""
        >
          <md-table-row>
            <md-table-cell
              v-for="(col, colIndex) in getImportColumnsForTable"
              :key="'tableColumn' + colIndex"
              ><strong>{{ col.file_field_name }}</strong></md-table-cell
            >
          </md-table-row>
          <md-table-row
            v-for="(userFields, userId) in getImportFieldsForTable"
            :key="'tableRow' + userId"
          >
            <md-table-cell
              v-for="(col, colIndex) in getImportColumnsForTable"
              :key="'tableRow' + colIndex"
            >
              <template v-if="col.is_identifier === 0">
                {{ userFields[col.id].old_value }}
                <md-icon>arrow_right_alt</md-icon>
                {{ userFields[col.id].new_value }}
              </template>
              <template v-if="col.is_identifier === 1">
                {{ userFields[col.id] }}
              </template>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </md-card-content>

      <md-card-actions>
        <md-button
          v-if="everythingLoaded"
          :disabled="updateRequest"
          native-type="button"
          @click.native.prevent="goBack"
          v-bind:class="{
            'md-primary': !formTouched,
            'md-warning': formTouched
          }"
          >Terug
        </md-button>
        <md-button
          v-if="everythingLoaded"
          :disabled="!formTouched || updateRequest"
          native-type="submit"
          @click.native.prevent="validate"
          class="md-success"
          >{{ saveButtonTitle }}
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import filePicker from "../Files/FilePicker.vue";
import swal from "sweetalert2";

export default {
  components: {
    filePicker,
    SlideYDownTransition
  },
  data() {
    return {
      templateId: null,
      status: 0,
      importTemplates: [],
      importFields: [],
      importTemplateFields: [],
      users: [],
      touched: {
        templateId: false,
        fileData: false
      },
      fileData: {
        fileData: null,
        filename: null
      },
      submitErrors: "",
      loaded: {
        import: false,
        importTemplates: false,
        importFields: false,
        importTemplateFields: false,
        users: false
      },
      updateRequest: false
    };
  },
  methods: {
    init() {
      if (this.$route.params.id !== undefined) {
        this.loadImport(this.$route.params.id);
      } else {
        this.templateId = null;
        this.loaded.import = true;
        this.loaded.importFields = true;
        this.loaded.importTemplateFields = true;
        this.loaded.users = true;

        setTimeout(this.resetTouched, 100);
      }

      this.loadImportTemplates();
    },
    validate() {
      if (this.$route.params.id === undefined) {
        this.saveImport();
      } else if (this.$route.params.id !== undefined && this.status === 0) {
        this.uploadFile();
      } else if (this.$route.params.id !== undefined && this.status === 1) {
        this.analyseData();
      } else if (this.$route.params.id !== undefined && this.status === 2) {
        this.processData();
      }
    },
    saveImport() {
      this.updateRequest = true;
      this.$http
        .post(
          this.$apiBaseUrl +
            "import/" +
            (this.$route.params.id !== undefined ? this.$route.params.id : ""),
          Object.assign({
            template_id: this.templateId,
            status: this.status
          })
        )
        .then(
          response => {
            setTimeout(this.resetTouched, 100);
            this.updateRequest = true;
            this.notifyVue(
              "Import succesvol opgeslagen",
              "check",
              "success",
              5000
            );

            if (this.$route.params.id === undefined) {
              this.$router.go(-1);
            }
          },
          response => {
            this.updateRequest = true;
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan import",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    uploadFile() {
      this.updateRequest = true;
      this.$http
        .post(
          this.$apiBaseUrl + "import/" + this.$route.params.id + "/upload",
          Object.assign({
            fileData: this.fileData.fileData,
            filename: this.fileData.filename
          })
        )
        .then(
          response => {
            this.fileData.fileData = null;
            this.fileData.filename = null;
            this.updateRequest = false;

            this.loadImportFields(this.$route.params.id);
            this.loadUsers();

            this.status = response.data.import.status;

            this.notifyVue(
              "Import bestand succesvol verstuurd naar de server",
              "check",
              "success",
              5000
            );

            this.analyseData();
          },
          response => {
            this.updateRequest = false;
            if (response.status === 422) {
              this.notifyVue(response.data.message, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens uploaden van bestand",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    analyseData() {
      this.updateRequest = true;
      this.$http
        .post(
          this.$apiBaseUrl + "import/" + this.$route.params.id + "/analyze",
          Object.assign({})
        )
        .then(
          response => {
            this.updateRequest = false;

            this.loadImportFields(this.$route.params.id);

            this.status = response.data.import.status;

            this.notifyVue(
              "Import bestand succesvol aangevuld met de huidige gegevens.",
              "check",
              "success",
              5000
            );
          },
          response => {
            this.updateRequest = false;
            if (response.status === 422) {
              this.notifyVue(response.data.message, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens aanvullen van de data met de huidige gegevens",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    processData() {
      this.updateRequest = true;
      this.$http
        .post(
          this.$apiBaseUrl + "import/" + this.$route.params.id + "/process",
          Object.assign({})
        )
        .then(
          response => {
            this.updateRequest = false;

            this.loadImportFields(this.$route.params.id);

            this.status = response.data.import.status;

            setTimeout(this.resetTouched, 100);

            this.notifyVue(
              "Import bestand succesvol verwerkt",
              "check",
              "success",
              5000
            );
          },
          response => {
            this.updateRequest = false;
            if (response.status === 422) {
              this.notifyVue(response.data.message, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens het verwerken van de data",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    goBack() {
      if (!this.formTouched) {
        this.$router.go(-1);
        return;
      }

      this.showSwal();
    },
    loadImport(id) {
      this.loaded.import = false;
      this.$http.get(this.$apiBaseUrl + "import/" + id).then(
        response => {
          this.templateId = response.data.import.template_id;
          this.status = response.data.import.status;

          if (this.templateId) {
            this.loadImportTemplateFields(this.templateId);
          }

          if (this.status >= 1) {
            this.loadImportFields(id);
            this.loadUsers();
          } else {
            this.loaded.importFields = true;
            this.loaded.users = true;
          }

          if (this.status === 1 || this.status === 2) {
            this.touched.name = true;
          } else {
            setTimeout(this.resetTouched, 100);
          }

          this.loaded.import = true;
        },
        response => {
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van import templates", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadImportTemplates() {
      this.loaded.importTemplates = false;
      this.$http.get(this.$apiBaseUrl + "import/templates").then(
        response => {
          this.importTemplates = response.data.importTemplates;

          this.loaded.importTemplates = true;
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het bekijken van import templates",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadImportFields(id) {
      this.loaded.importFields = false;
      this.$http.get(this.$apiBaseUrl + "import/fields/" + id).then(
        response => {
          this.importFields = response.data.importFields;

          this.loaded.importFields = true;
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het bekijken van import velden",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadImportTemplateFields(id) {
      this.loaded.importTemplateFields = false;
      this.$http.get(this.$apiBaseUrl + "import/templates/fields/" + id).then(
        response => {
          this.importTemplateFields = response.data.importTemplateFields;

          this.loaded.importTemplateFields = true;
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het bekijken van import velden",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadUsers() {
      this.loaded.users = false;
      this.$http.get(this.$apiBaseUrl + "users").then(
        response => {
          let users = response.data.users;

          for (var i = 0; i < users.length; i++) {
            if (users[i].lastNamePrefix == null) {
              users[i].lastNamePrefix = "";
            }
          }

          this.users = users;
          this.loaded.users = true;
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van gebruikers",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    getUserById(id) {
      for (let i in this.users) {
        if (this.users[i].id !== id) {
          continue;
        }

        return this.users[i];
      }

      return [];
    },
    resetTouched() {
      this.touched.name = false;
      this.touched.templateId = false;
      this.touched.fileData = false;
    },
    showSwal() {
      swal
        .fire({
          title: "Waarschuwing!",
          text: "Weet u zeker dat u de wijzigingen wilt negeren?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Ja, ga terug zonder op te slaan",
          cancelButtonText: "Annuleren",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$router.go(-1);
          } else if (result.dismiss === swal.DismissReason.cancel) {
          }
        });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  watch: {
    templateId() {
      if (this.everythingLoaded) {
        this.touched.templateId = true;
      }
    },
    fileData() {
      if (this.everythingLoaded) {
        this.touched.fileData = true;
      }
    }
  },
  computed: {
    title: function() {
      if (!this.everythingLoaded) {
        return "Laden";
      }
      if (this.$route.params.id !== undefined) {
        if (this.status === 1) {
          return "Import template - vergelijken met huidige gegevens";
        } else if (this.status === 2) {
          return "Import template - verwerk gegevens";
        } else if (this.status === 3) {
          return "Import template - gegevens verwerkt";
        }

        return "Import template - upload gegevens";
      }

      return "Import toevoegen - Kies een import template";
    },
    saveButtonTitle: function() {
      if (!this.everythingLoaded) {
        return "Opslaan";
      }
      if (this.$route.params.id !== undefined) {
        if (this.status === 0) {
          return "Bestand uploaden";
        } else if (this.status === 1) {
          return "Import aanvullen met huidige gegevens";
        } else if (this.status === 2) {
          return "Import verwerken";
        } else if (this.status === 3) {
          return "Import verwerkt";
        }

        return "Import template - upload gegevens";
      }

      return "Import toevoegen - Kies een import template";
    },
    formIcon: function() {
      if (!this.everythingLoaded) {
        return "hourglass_empty";
      }
      return "system_update_alt";
    },
    formTouched: function() {
      for (var i in this.touched) {
        if (this.touched[i]) {
          return true;
        }
      }

      return false;
    },
    filename: function() {
      if (this.fileData.filename === null) {
        return "";
      }
      return this.fileData.filename;
    },
    getImportColumnsForTable: function() {
      return this.importTemplateFields;
    },
    getImportFieldsForTable: function() {
      let userIds = [];

      for (let i in this.importFields) {
        if (userIds.includes(this.importFields[i].user_id)) {
          continue;
        }
        userIds.push(this.importFields[i].user_id);
      }

      let tableData = {};
      for (let u in userIds) {
        for (let c in this.getImportColumnsForTable) {
          for (let i in this.importFields) {
            if (this.importFields[i].user_id !== userIds[u]) {
              continue;
            }
            if (
              this.getImportColumnsForTable[c].id !==
              this.importFields[i].template_field_id
            ) {
              continue;
            }

            if (tableData[userIds[u]] === undefined) {
              tableData[userIds[u]] = {};
            }

            tableData[userIds[u]][this.importFields[i].template_field_id] = {};

            tableData[userIds[u]][this.importFields[i].template_field_id][
              "old_value"
            ] = JSON.parse(this.importFields[i].old_value);

            if (
              tableData[userIds[u]][this.importFields[i].template_field_id][
                "old_value"
              ].length === 0
            ) {
              tableData[userIds[u]][this.importFields[i].template_field_id][
                "old_value"
              ] = "(geen waarde)";
            }

            if (
              tableData[userIds[u]][this.importFields[i].template_field_id][
                "old_value"
              ].length === 1
            ) {
              tableData[userIds[u]][this.importFields[i].template_field_id][
                "old_value"
              ] = tableData[userIds[u]][this.importFields[i].template_field_id][
                "old_value"
              ].shift();
            }

            if (
              tableData[userIds[u]][this.importFields[i].template_field_id][
                "old_value"
              ] === null
            ) {
              tableData[userIds[u]][this.importFields[i].template_field_id][
                "old_value"
              ] = "(geen waarde)";
            }

            tableData[userIds[u]][this.importFields[i].template_field_id][
              "new_value"
            ] = JSON.parse(this.importFields[i].new_value);

            if (
              tableData[userIds[u]][this.importFields[i].template_field_id][
                "new_value"
              ].length === 0
            ) {
              tableData[userIds[u]][this.importFields[i].template_field_id][
                "new_value"
              ] = "(geen waarde)";
            }

            if (
              tableData[userIds[u]][this.importFields[i].template_field_id][
                "new_value"
              ].length === 1
            ) {
              tableData[userIds[u]][this.importFields[i].template_field_id][
                "new_value"
              ] = tableData[userIds[u]][this.importFields[i].template_field_id][
                "new_value"
              ].shift();
            }

            if (
              tableData[userIds[u]][this.importFields[i].template_field_id][
                "new_value"
              ] === null
            ) {
              tableData[userIds[u]][this.importFields[i].template_field_id][
                "new_value"
              ] = "(geen waarde)";
            }
          }

          if (this.getImportColumnsForTable[c].is_identifier === 1) {
            if (tableData[userIds[u]] === undefined) {
              tableData[userIds[u]] = {};
            }

            tableData[userIds[u]][
              this.getImportColumnsForTable[c].id
            ] = this.getUserById(userIds[u]).email;
          }
        }
      }

      return tableData;
    },
    everythingLoaded: function() {
      for (let i in this.loaded) {
        if (!this.loaded[i]) {
          return false;
        }
      }

      return true;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-card-content > span > .md-field.md-datepicker {
  padding-top: 15px;

  &:after {
    bottom: 20px;
  }
}
</style>
